/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayslipThemeColors } from './PlayslipThemeColors';
import {
    PlayslipThemeColorsFromJSON,
    PlayslipThemeColorsFromJSONTyped,
    PlayslipThemeColorsToJSON,
} from './PlayslipThemeColors';

/**
 * A new theme. Every colour role is replaced on save, so one left out is unset and the client
 * falls back to its built-in colour for that role.
 * @export
 * @interface PlayslipThemeCreateRequest
 */
export interface PlayslipThemeCreateRequest {
    /**
     * The reworded copy. Left out, the theme has none.
     * @type {{ [key: string]: string; }}
     * @memberof PlayslipThemeCreateRequest
     */
    messages?: { [key: string]: string; };
    /**
     * The retailer's logo URL. Left out or null, the theme has none.
     * @type {string}
     * @memberof PlayslipThemeCreateRequest
     */
    partnerLogoUrl?: string | null;
    /**
     * 
     * @type {PlayslipThemeColors}
     * @memberof PlayslipThemeCreateRequest
     */
    colors: PlayslipThemeColors;
    /**
     * The identifier a host app will send to select this theme. Fixed once created.
     * @type {string}
     * @memberof PlayslipThemeCreateRequest
     */
    themeId: string;
}

/**
 * Check if a given object implements the PlayslipThemeCreateRequest interface.
 */
export function instanceOfPlayslipThemeCreateRequest(value: object): value is PlayslipThemeCreateRequest {
    if (!('colors' in value) || value['colors'] === undefined) return false;
    if (!('themeId' in value) || value['themeId'] === undefined) return false;
    return true;
}

export function PlayslipThemeCreateRequestFromJSON(json: any): PlayslipThemeCreateRequest {
    return PlayslipThemeCreateRequestFromJSONTyped(json, false);
}

export function PlayslipThemeCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayslipThemeCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': json['messages'] == null ? undefined : json['messages'],
        'partnerLogoUrl': json['partnerLogoUrl'] == null ? undefined : json['partnerLogoUrl'],
        'colors': PlayslipThemeColorsFromJSON(json['colors']),
        'themeId': json['themeId'],
    };
}

export function PlayslipThemeCreateRequestToJSON(value?: PlayslipThemeCreateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'messages': value['messages'],
        'partnerLogoUrl': value['partnerLogoUrl'],
        'colors': PlayslipThemeColorsToJSON(value['colors']),
        'themeId': value['themeId'],
    };
}

